import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import WithdrawalsLayer from "../../components/banks/WithdrawalsLayer";

const Withdrawals = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Meus Saques" />
      <WithdrawalsLayer />
    </MasterLayout>
  );
};

export default Withdrawals;
